module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/ja_shikoku-8fdd43e566b0e8b6fe3ceabf630d3a9b.jpg";